module.exports = __webpack_public_path__ + "img/story1.7c2a3a28.webp";